module.exports = __webpack_public_path__ + "img/es.0cf21c67.svg";